module.exports = "https://static.wanderu.com/static/media/apple-store.6902bc18.png";